import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-200 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-navy-900 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-gold text-navy-900 hover:bg-gold-light focus:ring-gold shadow-[0_0_15px_rgba(200,169,106,0.3)] hover:shadow-[0_0_25px_rgba(200,169,106,0.5)]',
    secondary: 'bg-navy-800 text-white hover:bg-navy-700 focus:ring-navy-500 border border-navy-600',
    outline: 'bg-transparent text-gold hover:text-gold-light border border-gold/40 hover:border-gold focus:ring-gold'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-5 py-2.5 text-base',
    lg: 'px-8 py-3.5 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-245">
      {children}
    </button>;
}